<template>
  <div>
    <div v-if="!isMobileDevice()" class="title">
      <div>
        <img v-if="method === '支付宝'" src="~@/assets/svg/ali_app.svg" alt="">
        <img v-if="method === '微信'" src="~@/assets/svg/wx_app.svg" alt="">
      </div>
      <p style="font-size:18px;margin-left: 12px;">{{ method }}扫码支付</p>
    </div>
    <div v-if="!isMobileDevice()" class="order-info">
      <p style="font-size:36px;">￥{{amount}}</p>
      <vueQr :text="payUrl" :size="270"/>
      <!--    <p v-if="!isMobileDevice()" class="pay-info-link" @click="copyToClipboard">{{copyText}}</p>-->
      <p style="font-size:18px;">订单号：{{orderNo}}</p>
      <div style="display: flex;align-items: center;justify-content: center;">
        <img src="~@/assets/svg/qr_cashier.svg" alt="">
        <p style="font-size:18px;margin-left: 12px;">扫描二维码完成支付</p>
      </div>
    </div>
    <form v-if="showQuick" ref="orderForm" :action="submitUrl" method="get">
      <input v-for="item in params" :key="item.key" type="hidden" :name="item.key" :value="item.value" />
<!--      <input type="submit" value="提交到快钱">-->
    </form>
  </div>
</template>

<script>
import {redirectCashier,getOrderInfo} from '@/api/api'
import vueQr from "vue-qr";
export default {
  name: "QuickMoneyPayForm",
  components: {vueQr},
  data() {
    return {
      showQuick: false,
      orderNo: '',
      amount:'0.00',
      payUrl:'',
      method:'',
      submitUrl:'',
      params:[]
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    isMobileDevice: function() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    init() {
      const {method, token} = this.$router.history.current.params;

      if (method === 'wxpay') {
        this.method = '微信';
      } else if (method === 'alipay') {
        this.method = '支付宝';
      } else if (method === 'up') {
        this.method = '云闪付';
      }

      if (token) {
        redirectCashier(token).then(res => {
          this.orderNo = res.payOrderId;
          if (this.isMobileDevice()) {
            if (res.payInfo.includes('<form') && res.payInfo.includes('</form>') && res.payInfo.includes('<script>')) {
              const div = document.createElement('div') // 创建div
              div.innerHTML = res.payInfo // 将返回的form 放入div
              document.body.appendChild(div)
              document.forms[0].submit();
            } else if(this.isHttpUrl(res.payInfo)) {
              window.location.href = res.payInfo;
            } else {
              this.showQuick = true
              const result = JSON.parse(res.payInfo)
              const url = new URL(result.formData);
              const search = new URLSearchParams(url.search);
              search.forEach((value, key) => {
                this.params.push({key, value})
                if (key === 'signType') {
                  this.params.push({key: 'signMsg', value: result.signMsg})
                }
                if (key === 'merchantAcctId') {
                  this.params.push({key: 'terminalIp', value: result.terminalIp})
                  this.params.push({key: 'tdpformName', value: result.tdpformName})
                }
              })
              this.submitUrl = url.origin + url.pathname;

              setTimeout(() => {
                this.$refs.orderForm.submit()
              }, 300);
            }
          } else {
            getOrderInfo(token).then(info => {
              this.amount = info.amount / 100;
            })

            this.copyText = window.location.href;
            this.payUrl = window.location.href;
          }
        });
      }
    },
    isHttpUrl(str, caseSensitive = false) {
      if (typeof str !== 'string') return false;

      if (caseSensitive) {
        return str.startsWith('http://') || str.startsWith('https://');
      }

      const lower = str.toLowerCase();
      return lower.startsWith('http://') || lower.startsWith('https://');
    }
  }
}
</script>

<style scoped>

.title{
  text-align: center;
  border-bottom: 1px solid #ddd;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-info{
  width: 510px;
  margin: 18px auto 0 auto;
  text-align: center;
  border: 1px solid #e5e5e5;
  background-color: white;
}

.pay-info-link {
  font-size: .09rem;
  cursor: pointer;
  background-color: lightgrey;
  padding: 5px;
  margin: 0 30%;
  word-break: break-all;
}
</style>